"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (skills = [], equipment = [], equipmentBySkills = {}, i18n = {}) => 
// get list of equipment for each skill, keep unique and flatten to a single list
[...new Set([...equipment, ...skills.flatMap(skill => equipmentBySkills[skill])])]
    // find equipment description string in given language
    .map(id => i18n[`@lemonone/intl/equipment:${id}`])
    // filter out empty values
    .filter(Boolean)
    .sort();
//# sourceMappingURL=getEquipmentBySkills.js.map